export default __webpack_public_path__ + "static/media/i_bus-low_rd_dup_tagless.fdcb08d4.svg";